module.exports = __webpack_public_path__ + "static/media/trailing-arrow-transparent.54d6e662.svg";